export default "__VITE_ASSET__xh888y3Z__"